(function () {
    const showTooltip = (e, tooltip) => {
        let item = e.target;

        if(!item.classList.contains('custom-tooltip__item')) {
            item = item.closest('.custom-tooltip__item');
        }

        if(!item) {
            return;
        }

        const wrapper = item.closest('.custom-tooltip__wrapper');

        if(!wrapper) {
            return;
        }

        const tooltipTitleElement = tooltip.querySelector('.custom-tooltip__title');
        const tooltipTextElement = tooltip.querySelector('.custom-tooltip__text');
        const tooltipButtonElement = tooltip.querySelector('.custom-tooltip__link');

        if(
            !item.dataset?.tooltipTitle?.length &&
            !item.dataset?.tooltipText?.length &&
            (!item.dataset?.tooltipButtonText?.length || !item.dataset?.tooltipButtonLink?.length)
        ) {
            return;
        }

        if(tooltipTitleElement && item.dataset?.tooltipTitle?.length) {
            tooltipTitleElement.textContent = item.dataset.tooltipTitle;
            tooltipTitleElement.style.display = 'block';
        } else {
            tooltipTitleElement.style.display = 'none';
        }

        if(tooltipTextElement && item.dataset?.tooltipText?.length) {
            tooltipTextElement.textContent = item.dataset.tooltipText;
            tooltipTextElement.style.display = 'block';
        } else {
            tooltipTextElement.style.display = 'none';
        }

        if(tooltipButtonElement && item.dataset?.tooltipButtonText?.length && item.dataset?.tooltipButtonLink?.length) {
            tooltipButtonElement.textContent = item.dataset.tooltipButtonText;
            tooltipButtonElement.href = item.dataset.tooltipButtonLink;
            tooltipButtonElement.style.display = 'block';
        } else {
            tooltipButtonElement.style.display = 'none';
        }

        tooltip.style.display = 'block';

        Helper.moveToItem(wrapper, item, tooltip);
    }

    const hideTooltip = (e, tooltip) => {
        if(!e.target.classList.contains('product__advantages') && e.target.closest('.custom-tooltip__wrapper')) {
            return;
        }

        // when animation has been finished
        requestAnimationFrame(() => {
            tooltip.style.display = 'none';
        });
    }

    const init = () => {
        const tooltipWrappers = document.querySelectorAll('.custom-tooltip__wrapper');

        tooltipWrappers.forEach(tooltipWrapper => {
            const tooltipItems = tooltipWrapper.querySelectorAll('.custom-tooltip__item');
            const tooltip = tooltipWrapper.querySelector('.custom-tooltip');

            if(!tooltip) {
                return;
            }

            const handleShowTooltip = (event) => showTooltip(event, tooltip);
            const handleHideTooltip = (event) => hideTooltip(event, tooltip);

            tooltipItems.forEach(tooltipItem => {
                tooltipItem.removeEventListener('mouseover', handleShowTooltip);
                tooltipItem.removeEventListener('touchstart', handleShowTooltip);
                tooltipItem.addEventListener('mouseover', handleShowTooltip);
                tooltipItem.addEventListener('touchstart', handleShowTooltip);
            });

            tooltipWrapper.removeEventListener('mouseleave', handleHideTooltip);
            document.removeEventListener('click', handleHideTooltip);
            tooltipWrapper.addEventListener('mouseleave', handleHideTooltip);
            document.addEventListener('click', handleHideTooltip);
        });
    }

    init();
})();
